import React from 'react';
import styles from './styles.module.css';

import BackgroundImage from '../background-image';

export default ({ src, children }) => (
  <div className={styles.container}>
    <div className={styles.background}>
      <BackgroundImage src={src} height="100%" width="100%" />
    </div>
    <div className={styles.content}>{children}</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/background-container/index.js